import { DOCTYPES } from '@/constants/doctypes'
import { createDoctypeRoutes } from '@/routers/routes/createDoctypeRoutes'

const {
  create: routeAutoRepeatCreate,
  detail: routeAutoRepeatDetail,
  home: routeAutoRepeatsHome,
  root: routeAutoRepeatsRoot,
} = createDoctypeRoutes({
  createName: 'new-auto-repeat',
  createPath: 'new-auto-repeat',
  detailName: 'autoRepeatDetail',
  doctype: DOCTYPES.AUTO_REPEAT,
  homeName: 'auto-repeats-home',
  path: 'auto-repeats',
  views: {
    create: async () => await import('@/components/viewsExternal/autoRepeats/AddAutoRepeat.vue'),
    detail: async () => await import('@/components/viewsExternal/autoRepeats/ViewAutoRepeat.vue'),
    list: async () => await import('@/components/viewsExternal/autoRepeats/AutoRepeatView.vue'),
  },
})

export { routeAutoRepeatCreate, routeAutoRepeatDetail, routeAutoRepeatsHome, routeAutoRepeatsRoot }
